import vastu from "../../assets/icons/VASTHU-01.png";
import Acres from "../../assets/icons/2.3 acres-01.png";
import Blocks from "../../assets/icons/4 blocks 210 units.png";
import BHK from "../../assets/icons/2 BHK-01.png";
import SFT from "../../assets/icons/1050 sft-01.png";
import Clubhouse from "../../assets/icons/clubhouse-01.png";
import Kids from "../../assets/icons/kids play-01.png";
import Landscape from "../../assets/icons/designer landscape-01.png";
import Indoor from "../../assets/icons/indoor games-01.png";
import security from "../../assets/icons/security system-01.png";
import { useModal } from "../ModalContext";
import sideImage from "../../assets/images/au-7.jpg";
export default function Features() {
  const { openModal } = useModal();
  const featureItems = [
    { alttext: "Vastu Compliant", icon: vastu, label: "Vastu Compliant" },
    { alttext: "2.3 Acres", icon: Acres, label: "2.3 Acres" },
    {
      alttext: "4 Blocks 210 units",
      icon: Blocks,
      label: "4 Blocks 210 units",
    },
    { alttext: "2 BHK", icon: BHK, label: "2 BHK" },
    { alttext: "1050sft.", icon: SFT, label: "1050sft." },
    {
      alttext: "An 7,000 Sq. Ft. Clubhouse Designed for Community Living",
      icon: Clubhouse,
      label: "Clubhouse 7000sq. ft.",
    },
    { alttext: "Kids Play Areas", icon: Kids, label: "Kids Play Areas" },
    {
      alttext: "Designer Landscape",
      icon: Landscape,
      label: "Designer Landscape",
    },
    { alttext: "Indoor Games", icon: Indoor, label: "Indoor Games" },
    {
      alttext: "24/7 secured Community",
      icon: security,
      label: "24/7 secured Community",
    },
  ];
  return (
    <div
      className="bg-[#fdf6f6] py-14 xl:py-20 text-[#000] overflow-hidden"
      id="amenities"
    >
      <div className="max-w-screen-2xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-8 xl:mb-12">
          <h2 className="font-crimson text-3xl xl:text-5xl  pb-5 text-[#5e3920]">
           Spacious 2 BHK Apartments Designed for Comfortable Living
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-20 items-center">
          {/* Image */}
          <div className="overflow-hidden rounded-xl shadow-lg h-[55vh]">
            <img
              src={sideImage}
              alt="flats for sale in Patancheru"
              className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500"
            />
          </div>

          {/* Text Content */}
          <div className="flex flex-col justify-center">
            <p className="text-[28px] xl:text-[36px] font-semibold text-[#5e3920] mb-4 font-crimson">
              Discover a lot more with Aura by Tranquillo
            </p>
            <p className="text-[#000000d9] text-[16px] xl:text-[18px] font-inter leading-relaxed mb-6">
              Utilizing cost-efficient methods and technologies of today, Aura offers affordable housing while bringing together modern living luxuries within a gated community. The project is planned across 2.3 acres with 4 blocks and 210 units, offering 2 BHK homes of 1050 sq. ft. along with a clubhouse, children's play areas, designer landscaping and indoor games.
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 font-inter">
              {featureItems.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center text-center "
                >
                  <div className="bg-[#fff] w-16 h-16 flex items-center justify-center rounded-full mb-2">
                    {item.icon ? (
                      <img
                        src={item.icon}
                        alt={item.alttext}
                        className="w-8 h-8"
                      />
                    ) : (
                      <span className="text-[#5e3920] text-lg font-bold">
                        {item.label[0]}
                      </span>
                    )}
                  </div>
                  <p className="text-[#5e3920] font-medium text-sm">
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className="bg-[#fdf6f6] border-2 border-[#fff] rounded-[18px] px-3 py-6  max-w-[780px] w-full max-h-fit mx-auto mt-10 flex justify-center items-center flex-col "
          style={{
            boxShadow:
              "inset 3px 3px 47px 5px #ffffffa6, 0 6px 8px rgba(0,0,0,0.1)",
          }}
        >
          <h2 className="text-[20px] xl:text-[28px] font-crimson text-center xl:leading-[3.5rem]">
            
            Choose {" "}&nbsp;<span className="text-3xl xl:text-6xl tracking-wider ">AURA</span>{" "} as your New Home
          </h2>
          <p className="text-center sm:px-8 px-4 text-[#000000d9] text-[16px] xl:text-[18px] my-4 font-inter leading-relaxed">Choose Aura by Tranquillo for a 2 BHK home that brings together comfortable living spaces, a gated community environment and thoughtfully planned amenities in Nandigaon, Patancheru.</p>
          <button
            className="group relative inline-flex items-center gap-5 px-7 justify-center py-3 bg-[#c55b12] text-white 3xl:text-[18px]  rounded-2xl transition-shadow duration-300 font-Poppins my-4 font-medium w-[95%] md:w-[50%] lg:w-[40%] xl:w-[50%] overflow-hidden"
            style={{ boxShadow: "0 6px 8px rgba(197, 91, 18, 0.5)" }}
            onClick={openModal}
          >
            <span className="whitespace-nowrap ">
              Book Your Site Visit Today
            </span>
            <span className="relative grid place-items-center text-[#fff] transition-colors duration-300">
              {/* First SVG — moves out diagonally */}
              <svg
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="absolute w-[20px] h-[20px] transition-transform duration-300 ease-in-out transform group-hover:translate-x-[150%] group-hover:-translate-y-[250%]"
              >
                <path
                  d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  fill="currentColor"
                />
              </svg>

              {/* Second SVG — enters from bottom */}
              <svg
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="absolute w-[20px] h-[20px] transition-transform duration-300 ease-in-out transform translate-x-[-150%] translate-y-[250%] delay-100 group-hover:translate-x-0 group-hover:translate-y-0"
              >
                <path
                  d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
